import { PaymentAttribution } from 'core/enums/payment-type';
import { PaymentRequestRedirectResponse } from 'core/services/api/payment/payment-dpp';
import { PayAtExternalResponse } from 'core/services/api/payment/payment-pay-at-link';
import { NumberUtils } from 'utils/number.utils';
import { PaymentRequestType } from './payment-request';
import { PayAtRedirectResolution, PayAtRedirectResponse } from './payment-request-pay-at';

export class PaymentRequestDirectLink implements PaymentRequestType<PayAtExternalResponse> {

  constructor(private request: any) { }

  getDependantValues() {
    return Promise.resolve(this)
  }

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values
    }
    return this;
  }

  toPaymentRequestObject() {
    return this.request;
  }

  toTokenRequestObject() {
    const { customerNumber, amount, accountNumber, location } = this.request;
    const amountNumber = +`${amount}`;
    const amountInCents = isNaN(amountNumber) ? 0 : NumberUtils.FormatToDecimal(amountNumber * 100, '0-0', '');
    return {
      accountNumber: customerNumber,
      amount: `${amountInCents}`,
      customerId: customerNumber,
      customerRedirectUrl: location,
      clientReference: `${accountNumber}-${customerNumber}-ZA`
    };
  }

  handleResponse(response: any, paymentAttribution?: PaymentAttribution): Promise<PayAtRedirectResolution | boolean> {
    // TODO: improve conditional type logic
    if (Object.prototype.hasOwnProperty?.call(response, 'redirectUrl') && response?.target !== "_blank") {
      const res = response as PaymentRequestRedirectResponse;
      // sessionStorage.setItem('dstv-ss.tid', `${res.transactionId}:${res.paymentType}`);
      window.location.assign(res.redirectUrl  + (paymentAttribution ? `&jid=${paymentAttribution}` : ''));
      return Promise.resolve(false)
    }

    window.open(response.redirectUrl, response.target);
    return Promise.resolve(true);
  }
}